'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import Rating from 'ecosystem-marketplace-core/components/reviews/Rating';
import { STAR_RATING_FILLED } from 'ecosystem-marketplace-core/constants/reviews/RatingTypes';
import RadioInput from '../inputs/RadioInput';
const ratingValues = [4, 3, 2, 1];

const OverallRatingToggleGroup = ({
  onChange,
  value: checkedValue
}) => {
  const checkedValueNumber = parseInt(checkedValue, 10) || 0;
  return /*#__PURE__*/_jsx(UIToggleGroup, {
    name: "rating",
    children: ratingValues.map(rating => /*#__PURE__*/_jsxs(RadioInput, {
      checked: rating === checkedValueNumber,
      onChange: ({
        target: {
          value
        }
      }) => onChange(value),
      value: rating,
      alignment: "center",
      children: [/*#__PURE__*/_jsx("div", {
        // We overlay a div onto the Rating component to intercept click events and trigger the
        // on change handler, since the disabled static rating kills click event propagation.
        style: {
          width: '100%',
          height: '100%',
          position: 'absolute',
          cursor: 'pointer',
          zIndex: 5
        },
        onClick: () => onChange(`${rating}`)
      }), /*#__PURE__*/_jsx(Rating, {
        rating: rating,
        type: STAR_RATING_FILLED,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.storefront.filters.rating.andUp"
        }),
        labelSize: "sm"
      })]
    }, rating))
  });
};

OverallRatingToggleGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};
export default OverallRatingToggleGroup;